/**
 * Created by Juno Peng on 12/5/2023.
 * Description:
 * Ag-grid Edit/delete button
 * ------ maintenance history ------
 * history: Created by Bowen Li on 6/17/2019.
 */

import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { take } from 'rxjs/operators';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { AppState } from '../../redux';
import { DataproviderActionTypes } from '../../redux/actions/dataprovider.actions';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { FlatFileActionService } from './upload-flat-file-dialog.service';
import { StoreQuerierService } from '../../services/store-querier.service';
import { DataProviderService } from '../../tamalelibs/services/dataprovider.service';
import { Router } from '@angular/router';

@Component({
    selector: 'tam-flat-file-action-button',
    template: `
        <div kendoTooltip position="bottom" class="button-column">
            <smart-icon name='pencil' (click)='editClicked($event)' title="Edit"
                        [ngClass]="{'smart-icon-disable': !isPPCUser, 'smart-icon light': isPPCUser}">
            </smart-icon>
            <smart-icon name='trash' (click)='deleteClicked($event)' title="Delete"
                        [ngClass]="{'smart-icon-disable': !isPPCUser, 'smart-icon light': isPPCUser}">
            </smart-icon>
        </div>
    `,
    styleUrls: ['./flat-file-management.component.scss']
})
export class FlatFileActionButtonComponent implements OnInit, ICellRendererAngularComp {
    item: any;
    isPPCUser = false;
    private _currentUser: SystemUser;

    constructor(
        private _alertWindow: AlertWindowService,
        private _dataProviderService: DataProviderService,
        private _flatFileActionService: FlatFileActionService,
        private _router: Router,
        private _storeQuerier: StoreQuerierService,
        private _store: Store<AppState>,
        private _toast: ToastService,
    ) { }

    agInit(params: any): void {
        this.item = params.data;
    }

    ngOnInit() {
        this._currentUser = this._storeQuerier.getCurrentUser();
        this.isPPCUser = this._currentUser.credential.publishPubConfiguration;
    }

    refresh(): boolean {
        return false;
    }

    public deleteClicked(event): boolean {
        if (this.isPPCUser) {
            const subscription = this._alertWindow.warn('Delete confirmation required',
                ['Are you sure you want to delete this setting?'], 'Delete')
                .subscribe((result: boolean) => {
                    if (result) {
                        const id = this.item.id;
                        this._dataProviderService.remove(id).pipe(
                            take(1),
                        ).subscribe(() => {
                            this._toast.notify({
                                message: this.item.name + ' successfully deleted.',
                                style: NotificationStyles.Success
                            });
                            this._store.dispatch({
                                type: DataproviderActionTypes.DELETE_CONFIG,
                                payload: id,
                            });
                        });
                    }
                    subscription.unsubscribe();
                });
        } else {
            return false;
        }
    }

    public editClicked(event): boolean {
        if (this.isPPCUser) {
            // type value: 0 rich client, 1 flat file, 2 sql mdl
            this._router.navigate(['dataimport'], {
                queryParams: {
                    id: this.item.id,
                    action: 'edit',
                    type: this.item.type
                },
                skipLocationChange: true,
            });
        } else {
            return false;
        }
    }
}
